import { FaRegCheckCircle } from "react-icons/fa";

import aiIcon from "../../../../assets/ai-icon-filled.svg";
import { PLUM_PURPLE_800, SUCCESS_GREEN } from "../../colors";
import FlexBox from "../../FlexBox";
import { Body1, H3 } from "../../Headings";
import { SessionBulletIcon, SessionBulletRow } from "../styles";

const SessionNotesStep = () => (
  <FlexBox column rowGap="1.5rem">
    <FlexBox align="center" justify="center" columnGap="0.5rem">
      <img src={aiIcon} alt="AI icon" width="32" height="32" />
      <H3 bold color={PLUM_PURPLE_800}>
        Session Summary
      </H3>
    </FlexBox>
    <FlexBox column rowGap="1rem">
      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          Get <strong> auto-summarised session notes</strong> to quickly review
          key information.
        </Body1>
      </SessionBulletRow>

      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          <strong>Track your client's journey</strong> and{" "}
          <strong>gain actionable insights</strong> into client development and
          treatment effectiveness.
        </Body1>
      </SessionBulletRow>

      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          <strong>Manage permissions </strong>and
          <strong> enable or disable transcription</strong> based on your
          specific preferences.
        </Body1>
      </SessionBulletRow>
    </FlexBox>
  </FlexBox>
);

export default SessionNotesStep;
